import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"

import { formatDateTime } from "../../time"

/**
 * This component takes an array of dates and formats them
 *
 * @param {string} className to make styling easier
 * @param {node} children this can be a function that takes the formatted dates as param
 * @param {array} dates the array of dates to be formatted
 * @param {string} formatFrom the format in which the dates are currently in eg. dddd Do MMMM YYYY
 * @param {string} formatTo the format in which the dates should be formatted into eg. ddd Do MMM
 * @param {bool} showTime if times should be displayed or not (default false)
 * @returns {node} translated dates
 */
function Dates({
  className,
  children,
  dates,
  formatFrom,
  formatTo,
  showTime = false,
  ...otherProps
}) {
  const formattedDates = _.map(dates, date => formatDateTime(date, formatFrom, formatTo, showTime))

  return (
    <div className={classNames("oj-dates", className)} {...otherProps}>
      {children ? children(formattedDates) : formattedDates}
    </div>
  )
}

Dates.propTypes = {
  className: PropTypes.string,
  children: PropTypes.func,
  dates: PropTypes.arrayOf(PropTypes.string).isRequired,
  formatFrom: PropTypes.string,
  formatTo: PropTypes.string.isRequired,
  showTime: PropTypes.bool
}

export default Dates
